// NHÓM 2 THAO TÁC XÂY KÊNH (07/10/2026, người dùng duyệt): ĐĂNG BÀI lên kênh CỦA MÌNH + CHỦ KÊNH thả tim / ghim bình luận.
//  · facebook/dang_bai_tuong — đăng một bài lên trang cá nhân (tường): nội dung nguyên văn hoặc AI soạn theo chủ đề; tuỳ chọn KÈM ẢNH Kho ảnh (kem_anh — cơ chế
//    src/shared/kem-anh.ts: ảnh đính vào hộp "Tạo bài viết" ngay trước khi gõ). Hộp "Tạo bài viết" + nút Đăng = đường của dang_bai_trang (đã đo 04/10).
//  · youtube/dang_bai_cong_dong — bài Cộng đồng (tab Bài đăng của kênh mình): đọc @handle (như tra_loi_binh_luan_kenh_minh), mở /@handle/posts, soạn, Đăng.
//  · reddit/dang_bai — đăng bài vào MỘT cộng đồng: đọc luật cộng đồng ở thanh bên trước; luật cấm quảng cáo / tự quảng bá → AI soạn với guide KHONG_SAN_PHAM
//    (không đưa hồ sơ sản phẩm + chặn tất định câu có tên sản phẩm — khong-san-pham.ts); tiêu đề ≤ 300 ký tự; Create Post → Title → Body → Post.
//  · x/dang_bai_anh — đăng bài KÈM ẢNH Kho ảnh: khối RIÊNG cùng đường đăng của x/dang_bai (x/dang_bai cũ giữ nguyên YAML / hash).
//  · youtube|tiktok/tim_ghim_binh_luan — CHỦ KÊNH trên video của mình: thả tim (YouTube) / thích (TikTok) tối đa so_tim bình luận của NGƯỜI KHÁC chưa được thả tim
//    (bỏ của chính kênh, bỏ đã có tim — sổ cái), và ghim MỘT bình luận có chữ ghim_chu (để trống = không ghim).
// Đăng bài lên kênh: rủi ro cao, có duyệt, sổ cái theo nội dung (không đăng trùng), hạn mức riêng "dang_bai_kenh" (mặc định 3/ngày — han-muc-ngay.ts).
//
// ĐỐI CHIẾU KHẢO SÁT THẬT 04/10/2026:
//  ĐÃ ĐO: FB trang cá nhân — div[role=button] CHỮ "Bạn đang nghĩ gì?" (trang_ca_nhan_toi #134); hộp div[role=dialog][aria-label="Tạo bài viết"] + ô Lexical role=textbox
//         + nút aria-label "Ảnh/video" + nút aria-label "Đăng" (hop_tao_bai_ca_nhan #17 #24 #29 #35). YouTube — kênh mình có tab "Bài đăng" (kenh_minh_video #173),
//         nút ảnh đại diện + menu @handle (L-69); luồng bình luận ytd-comment-thread-renderer > #comment … #action-buttons (video #186-#219).
//         Reddit — trang cộng đồng có button[data-testid="create-post"] "Create Post" (cong_dong #14).
//  CHƯA KIỂM TRÊN TRANG THẬT (ghi tại từng hằng): input[type=file] ẩn trong hộp "Tạo bài viết" + ảnh trong bài vừa đăng (FB); ô soạn / nút Đăng bài Cộng đồng
//    (ytd-backstage-post-dialog-renderer — kênh khảo sát không phải kênh mình); trang soạn bài Reddit (ô Title / Body / nút Post — khảo sát /submit bị chuyển sang
//    đăng nhập) + khối luật ở thanh bên; nút tim chủ kênh #creator-heart-button + menu Tác vụ → "Ghim" + hộp xác nhận (YouTube); nút tim / menu "…" → "Pin"
//    của bình luận TikTok (khảo sát TikTok bị CAPTCHA).
import type { KhoiMau } from "./tu-dung";
import { kemAnhHoc, TS_KEM_ANH_TAT_CA } from "./kem-anh";
import { KHONG_SAN_PHAM, RE_LUAT_CAM_QC } from "./khong-san-pham";
import { KHONG_QC } from "./reddit-khoi";
import { MO_BINH_LUAN_ACTIONS as YT_MO_BINH_LUAN, YT_KENH_VIDEO_SPEC, YT_LAY_KENH_MINH } from "./yt-khoi";
import { MO_BINH_LUAN_ACTIONS as TT_MO_BINH_LUAN, TT_NICK_SPEC, TT_VIDEO_CA_NHAN_SPEC } from "./tt-khoi";
import { DANG_BAI_ACTIONS as X_DANG_BAI_ACTIONS, X_HAU_KIEM_ANH, X_KEM_ANH } from "./x-khoi";

const TOI_DA_BAI = 3000; // ký tự — bài dài hơn coi là nhầm (gõ từng ký tự rất lâu)
const dungNoiDung = (bien: string, noiDung: string, chuDe: string, noi: string) => [
  { dk: `len(trim(${noiDung})) > 0 or len(trim(${chuDe})) > 0`, ly_do: `chưa có nội dung lẫn chủ đề để đăng ${noi} — điền một trong hai rồi chạy lại` },
  { dk: `len(${bien}) <= ${TOI_DA_BAI}`, ly_do: `nội dung dài {{len(${bien})}} ký tự, vượt ngưỡng ${TOI_DA_BAI} ký tự — chặn, không đăng (rút gọn rồi chạy lại)` },
];
const dungSoan = (bien: string) => [
  { dk: `len(trim(${bien})) > 0`, ly_do: "AI chưa soạn được nội dung — không đăng" },
  { dk: `len(${bien}) <= ${TOI_DA_BAI}`, ly_do: `bài AI soạn dài {{len(${bien})}} ký tự, vượt ngưỡng ${TOI_DA_BAI} ký tự — chặn, không đăng` },
];

// ===================== FACEBOOK — ĐĂNG BÀI LÊN TƯỜNG =====================
const FB_O_MO_SOAN_TUONG = { describe: "ô 'Bạn đang nghĩ gì?' trên trang cá nhân (mở hộp Tạo bài viết)", ladder: [
  { t: "text", text: "Bạn đang nghĩ gì?", tag: "div" },
  { t: "xpath", xpath: `(//div[@role="main"]//div[@role="button"][contains(normalize-space(.),"Bạn đang nghĩ gì") or contains(normalize-space(.),"What's on your mind")])[1]` },
] };
const FB_HOP_TAO_BAI = { describe: "ô soạn trong hộp 'Tạo bài viết'", vung: "tao_bai", ladder: [{ t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"]' }] };
const FB_DANG_TUONG_ACTIONS = [
  { kind: "type", target: { describe: "ô soạn bài trong hộp thoại 'Tạo bài viết' (bài đăng lên trang cá nhân)", vung: "tao_bai", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"][data-lexical-editor="true"]' },
    { t: "css", sel: 'div[role="dialog"] div[role="textbox"][contenteditable="true"]' },
  ] }, text: "{{bai_tuong}}", clear: true },
  // Không nấc AI: nút mờ (aria-disabled) thì không nấc nào khớp → chờ hết giờ rồi dừng, không bấm.
  { kind: "click", target: { describe: "nút Đăng ĐANG BẬT trong hộp thoại 'Tạo bài viết'", vung: "tao_bai", ladder: [
    { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Đăng"]:not([aria-disabled="true"])' },
    { t: "css", sel: 'div[role="dialog"] div[role="button"][aria-label="Post"]:not([aria-disabled="true"])' },
  ] } },
];
// CHƯA KIỂM: ảnh trong bài vừa đăng (bài trên dòng thời gian chứa đầu chữ đã gõ có <img> không phải emoji).
const FB_HAU_KIEM_ANH_BAI = [{ t: "locator_visible" as const, target: { describe: "ảnh trong bài vừa đăng lên trang cá nhân", ladder: [
  { t: "xpath" as const, xpath: '(//div[@role="main"]//div[@aria-posinset][contains(normalize-space(.), {{ xpath_chu(dau_chu(cau_da_go, 40)) }})]//a[contains(@href,"photo")]//img)[1]' },
] } }];
const FB_DANG_TUONG: KhoiMau = {
  ten: "dang_bai_tuong",
  moTa: `Đăng MỘT bài lên trang cá nhân (tường) Facebook của nick: nội dung nguyên văn (noi_dung) hoặc AI soạn theo chủ đề (chu_de) với giọng của chính mình; tuỳ chọn KÈM ẢNH từ Kho ảnh (kem_anh). Mở trang cá nhân → 'Bạn đang nghĩ gì?' → gõ vào hộp Tạo bài viết → Đăng (rủi ro cao — có duyệt). Dừng có lý do nếu thiếu cả nội dung lẫn chủ đề, nội dung > ${TOI_DA_BAI} ký tự, nút Đăng mờ. Sổ cái chống đăng trùng nội dung; hạn mức đăng bài lên kênh mỗi ngày (mặc định 3).`,
  thamSo: [
    { ten: "chu_de", moTa: "chủ đề để AI soạn bài (bỏ trống nếu điền sẵn nội dung)", kieu: "chuoi", macDinh: "" },
    { ten: "noi_dung", moTa: `nội dung đăng NGUYÊN VĂN (tối đa ${TOI_DA_BAI} ký tự); bỏ trống = AI soạn theo chủ đề`, kieu: "chuoi", macDinh: "" },
    ...TS_KEM_ANH_TAT_CA,
  ],
  params: {
    chu_de_tuong: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài đăng tường (AI soạn)" },
    noi_dung_tuong: { type: "string", default: "{{ts.noi_dung}}", label: "Nội dung bài đăng tường (để trống = AI soạn)" },
  },
  trangThu: "https://www.facebook.com/me/ (khảo sát trang_ca_nhan_toi + hop_tao_bai_ca_nhan 04/10)",
  yamlSteps: `  - id: lay_noi_dung_tuong
    template: "{{noi_dung_tuong}}"
    into: bai_tuong

  - id: soan_bai_tuong
    when: "len(trim(noi_dung_tuong)) == 0"
    generate:
      input: "Viết MỘT bài đăng lên trang cá nhân (tường) Facebook của chính bạn về: {{chu_de_tuong}} — giọng tự nhiên như người thật chia sẻ, không chèn liên kết hay số điện thoại"
      guide: knowledge
      max_words: 120
      max_chars: ${TOI_DA_BAI}
    into: bai_tuong

  - id: mo_hop_tao_bai_tuong
    on: web
    do: "mở trang cá nhân rồi bấm ô 'Bạn đang nghĩ gì?' để mở hộp Tạo bài viết"
    timeout: 30s

  - id: dang_bai_tuong
    on: web
    do: "gõ {{bai_tuong}} vào hộp Tạo bài viết rồi bấm Đăng"
    expect: "bài hiện trên trang cá nhân"
    risk: high
    idempotent: unsafe
    timeout: 90s
    ledger: da_dang_tuong`,
  learned: {
    lay_noi_dung_tuong: { dung_neu_sai: dungNoiDung("bai_tuong", "noi_dung_tuong", "chu_de_tuong", "lên trang cá nhân") },
    soan_bai_tuong: { dung_neu_sai: dungSoan("bai_tuong") },
    mo_hop_tao_bai_tuong: {
      actions: [{ kind: "navigate", url: "{{goc}}me/" }, { kind: "click", target: FB_O_MO_SOAN_TUONG }],
      postcondition: [{ t: "locator_visible", target: FB_HOP_TAO_BAI }],
    },
    dang_bai_tuong: {
      actions: FB_DANG_TUONG_ACTIONS,
      postcondition: [{ t: "locator_gone", target: FB_HOP_TAO_BAI }, { t: "text_visible", text: "{{ dau_chu(bai_tuong, 60) }}" }],
      dem_ngay: "dang_bai_kenh",
      // CHƯA KIỂM: input[type=file] (nhận ảnh) nằm trong hộp "Tạo bài viết" cùng ô soạn (nút "Ảnh/video" ĐÃ ĐO #29).
      kem_anh: kemAnhHoc(0, FB_HAU_KIEM_ANH_BAI, { o_tep: 'input[type="file"]', ngu_canh: "{{bai_tuong}}" }),
    },
  },
};

// ===================== YOUTUBE — BÀI CỘNG ĐỒNG =====================
// CHƯA KIỂM TRÊN TRANG THẬT: hộp soạn bài trên tab Bài đăng của kênh MÌNH (ytd-backstage-post-dialog-renderer: vùng chữ mờ → ô #contenteditable-textarea → #submit-button).
const YT_CD = "ytd-backstage-post-dialog-renderer";
const YT_O_SOAN_CD = { describe: "ô soạn bài Cộng đồng (bấm để mở) trên tab Bài đăng của kênh mình", ladder: [
  { t: "css", sel: `${YT_CD} #placeholder-area` },
  { t: "css", sel: `#backstage-post-dialog ${YT_CD}` },
  { t: "xpath", xpath: `(//${YT_CD}//*[@contenteditable="true"])[1]` },
] };
const YT_DANG_CD_ACTIONS = [
  { kind: "click", target: YT_O_SOAN_CD },
  { kind: "type", target: { describe: "ô nhập nội dung bài Cộng đồng", ladder: [
    { t: "css", sel: `${YT_CD} #contenteditable-textarea[contenteditable="true"]` },
    { t: "css", sel: `${YT_CD} [contenteditable="true"]` },
  ] }, text: "{{bai_cd_yt}}", clear: true },
  { kind: "click", target: { describe: "nút Đăng của hộp bài Cộng đồng", ladder: [
    { t: "css", sel: `${YT_CD} #submit-button button` },
    { t: "xpath", xpath: `(//${YT_CD}//button[normalize-space()="Đăng" or normalize-space()="Post"])[1]` },
  ] } },
];
const YT_DANG_CD: KhoiMau = {
  ten: "dang_bai_cong_dong",
  moTa: `Đăng MỘT bài Cộng đồng (tab Bài đăng) lên kênh YouTube CỦA MÌNH: máy đọc @handle kênh đang đăng nhập, mở /@handle/posts, gõ nội dung (noi_dung nguyên văn hoặc AI soạn theo chu_de với tư cách chủ kênh) rồi bấm Đăng (rủi ro cao — có duyệt). Kênh chưa có quyền đăng bài Cộng đồng thì không có ô soạn → dừng có lý do. Sổ cái chống đăng trùng; hạn mức đăng bài lên kênh mỗi ngày (mặc định 3).`,
  thamSo: [
    { ten: "chu_de", moTa: "chủ đề để AI soạn bài Cộng đồng (bỏ trống nếu điền sẵn nội dung)", kieu: "chuoi", macDinh: "" },
    { ten: "noi_dung", moTa: `nội dung đăng NGUYÊN VĂN (tối đa ${TOI_DA_BAI} ký tự); bỏ trống = AI soạn theo chủ đề`, kieu: "chuoi", macDinh: "" },
  ],
  params: {
    chu_de_cd_yt: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài Cộng đồng (AI soạn)" },
    noi_dung_cd_yt: { type: "string", default: "{{ts.noi_dung}}", label: "Nội dung bài Cộng đồng (để trống = AI soạn)" },
  },
  trangThu: "CHƯA kiểm trên trang thật (hộp soạn bài Cộng đồng của kênh mình); @handle đo L-69",
  yamlSteps: `  - id: lay_noi_dung_cd_yt
    template: "{{noi_dung_cd_yt}}"
    into: bai_cd_yt

  - id: soan_bai_cd_yt
    when: "len(trim(noi_dung_cd_yt)) == 0"
    generate:
      input: "Viết MỘT bài Cộng đồng YouTube (bạn là CHỦ KÊNH, viết cho người đăng ký kênh) về: {{chu_de_cd_yt}} — ngắn gọn, thân thiện, không chèn liên kết"
      guide: knowledge
      max_words: 100
      max_chars: ${TOI_DA_BAI}
    into: bai_cd_yt

  - id: mo_trang_cd_yt
    on: web
    do: "mở YouTube để đọc kênh đang dùng"
    expect: "trang YouTube"

  - id: mo_menu_cd_yt
    on: web
    do: "bấm ảnh đại diện kênh (góc trên phải) để xem @handle kênh đang dùng"
    expect: "menu ảnh đại diện mở"
    timeout: 20s

  - id: lay_kenh_cd_yt
    on: web
    extract: "@handle kênh đang đăng nhập (menu ảnh đại diện)"
    into: kenh_cd_yt
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_cd_yt
    on: web
    do: "đóng menu ảnh đại diện (phím Esc)"
    optional: true

  - id: mo_tab_bai_dang_yt
    on: web
    do: "mở tab Bài đăng của kênh {{kenh_cd_yt}}"
    expect: "url chứa /posts"

  - id: dang_bai_cd_yt
    on: web
    do: "bấm ô soạn bài Cộng đồng, gõ {{bai_cd_yt}} rồi bấm Đăng"
    expect: "bài hiện ở tab Bài đăng"
    risk: high
    idempotent: unsafe
    timeout: 90s
    ledger: da_dang_cong_dong_yt`,
  learned: {
    lay_noi_dung_cd_yt: { dung_neu_sai: dungNoiDung("bai_cd_yt", "noi_dung_cd_yt", "chu_de_cd_yt", "lên tab Bài đăng") },
    soan_bai_cd_yt: { dung_neu_sai: dungSoan("bai_cd_yt") },
    mo_trang_cd_yt: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    mo_menu_cd_yt: { actions: [{ kind: "click", target: { describe: "ảnh đại diện kênh (góc trên phải) — chưa đăng nhập YouTube thì không có nút này", ladder: [{ t: "css", sel: "button#avatar-btn" }, { t: "css", sel: "#avatar-btn" }] } }], postcondition: [{ t: "dom_exists", sel: "ytd-multi-page-menu-renderer" }] },
    lay_kenh_cd_yt: YT_LAY_KENH_MINH,
    dong_menu_cd_yt: { actions: [{ kind: "press", key: "Escape" }] },
    mo_tab_bai_dang_yt: { actions: [{ kind: "navigate", url: "{{goc}}{{kenh_cd_yt}}/posts" }], postcondition: [{ t: "url_contains", s: "{{kenh_cd_yt}}/posts" }] },
    dang_bai_cd_yt: { actions: YT_DANG_CD_ACTIONS, postcondition: [{ t: "text_visible", text: "{{ dau_chu(bai_cd_yt, 60) }}" }], dem_ngay: "dang_bai_kenh" },
  },
};

// ===================== REDDIT — ĐĂNG BÀI VÀO CỘNG ĐỒNG =====================
// Luật cộng đồng ở thanh bên (CHƯA KIỂM — cùng vùng với RD_KIEM_BAI_SPEC.cam_qc của tim_roi_binh_luan).
const RD_LUAT_SPEC = {
  mode: "list",
  list: { describe: "luật cộng đồng Reddit (thanh bên của trang cộng đồng — một mục: cả trang)", ladder: [{ t: "css", sel: "body" }] },
  fields: {
    cam_qc: { sel: '#right-sidebar-container, aside, [slot="sidebar"]', attr: "text", phan_loai: [{ re: RE_LUAT_CAM_QC, gt: "cam_qc" }], mac_dinh: "" },
    luat: { sel: '#right-sidebar-container, aside, [slot="sidebar"]', attr: "text", regex: "^([\\s\\S]{0,800})" },
  },
};
// CHƯA KIỂM TRÊN TRANG THẬT: trang soạn bài (/r/<tên>/submit) — ô Title (faceplate-textarea-input name=title, textarea trong shadow), ô Body (shreddit-composer
// contenteditable), nút Post (#submit-post-button). Nút "Create Post" ĐÃ ĐO (cong_dong #14).
const RD_DANG_ACTIONS = [
  { kind: "navigate", url: "{{cong_dong_dang_url}}" },
  { kind: "click", target: { describe: "nút Create Post của cộng đồng", ladder: [
    { t: "css", sel: 'button[data-testid="create-post"]' },
    { t: "xpath", xpath: '(//*[self::button or self::a][normalize-space()="Create Post" or normalize-space()="Tạo bài viết"])[1]' },
  ] } },
  { kind: "type", target: { describe: "ô Title (tiêu đề bài)", ladder: [
    { t: "css", sel: 'textarea[name="title"]' },
    { t: "css", sel: 'faceplate-textarea-input[name="title"]' },
  ] }, text: "{{tieu_de_rd}}", clear: true },
  { kind: "type", target: { describe: "ô Body (nội dung bài)", ladder: [
    { t: "css", sel: 'shreddit-composer div[contenteditable="true"]' },
    { t: "css", sel: 'div[name="body"][contenteditable="true"]' },
  ] }, text: "{{noi_dung_bai_rd}}", clear: true },
  { kind: "click", target: { describe: "nút Post (đăng bài)", ladder: [
    { t: "css", sel: "#submit-post-button" },
    { t: "css", sel: 'button[type="submit"]', text: "Post" },
  ] } },
];
const RD_TIEU_DE_TOI_DA = 300;
const RD_DANG_BAI: KhoiMau = {
  ten: "dang_bai",
  moTa: `Đăng MỘT bài vào MỘT cộng đồng Reddit (cong_dong_url): đọc luật cộng đồng trước; AI soạn TIÊU ĐỀ (≤ ${RD_TIEU_DE_TOI_DA} ký tự) và NỘI DUNG theo chủ đề như một thành viên cộng đồng — cộng đồng cấm quảng cáo / tự quảng bá thì KHÔNG nhắc sản phẩm (máy chặn câu có tên sản phẩm); bấm Create Post, gõ tiêu đề + nội dung rồi Post. Rủi ro cao — có duyệt; sổ cái chống đăng trùng; hạn mức đăng bài lên kênh mỗi ngày (mặc định 3). KHÔNG bỏ phiếu.`,
  thamSo: [
    { ten: "cong_dong_url", moTa: "địa chỉ cộng đồng sẽ đăng bài (https://www.reddit.com/r/<tên>/)", kieu: "chuoi", batBuoc: true },
    { ten: "chu_de", moTa: "chủ đề / câu hỏi của bài (AI soạn tiêu đề + nội dung đúng chủ đề cộng đồng)", kieu: "chuoi", batBuoc: true },
  ],
  params: {
    cong_dong_dang_url: { type: "string", default: "{{ts.cong_dong_url}}", label: "Cộng đồng Reddit sẽ đăng bài" },
    chu_de_dang_rd: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài Reddit" },
  },
  trangThu: "https://www.reddit.com/r/<tên>/ (Create Post — khảo sát cong_dong 04/10); trang soạn bài: CHƯA kiểm trên trang thật",
  yamlSteps: `  - id: dat_tieu_de_rd
    template: "{{ '' }}"
    into: tieu_de_rd

  - id: dat_noi_dung_bai_rd
    template: "{{ '' }}"
    into: noi_dung_bai_rd

  - id: mo_cong_dong_dang_rd
    on: web
    do: "mở cộng đồng {{cong_dong_dang_url}} để đọc luật trước khi đăng"
    expect: "trang cộng đồng"

  - id: doc_luat_dang_rd
    on: web
    extract: "luật cộng đồng Reddit (thanh bên): cam_qc, luat"
    into: ds_luat_rd
    timeout: 10s

  - id: soan_tieu_de_rd
    when: "len(ds_luat_rd) > 0 and not ds_luat_rd[0].cam_qc"
    generate:
      input: "Viết TIÊU ĐỀ (một dòng, tối đa ${RD_TIEU_DE_TOI_DA} ký tự) cho một bài đăng Reddit về: {{chu_de_dang_rd}} — luật cộng đồng (tóm tắt): {{ str(ds_luat_rd[0].luat) }}. ${KHONG_QC}"
      guide: knowledge
      max_words: 30
      max_chars: ${RD_TIEU_DE_TOI_DA}
    into: tieu_de_rd

  - id: soan_noi_dung_bai_rd
    when: "len(ds_luat_rd) > 0 and not ds_luat_rd[0].cam_qc"
    generate:
      input: "Viết phần nội dung cho bài đăng Reddit có tiêu đề: {{tieu_de_rd}} — chủ đề: {{chu_de_dang_rd}}. ${KHONG_QC}"
      guide: knowledge
      max_words: 220
      max_chars: ${TOI_DA_BAI}
    into: noi_dung_bai_rd

  - id: soan_tieu_de_rd_khong_qc
    when: "len(ds_luat_rd) > 0 and ds_luat_rd[0].cam_qc"
    generate:
      input: "Viết TIÊU ĐỀ (một dòng, tối đa ${RD_TIEU_DE_TOI_DA} ký tự) cho một bài đăng Reddit về: {{chu_de_dang_rd}} — như một thành viên cộng đồng hỏi / chia sẻ kinh nghiệm; KHÔNG nhắc sản phẩm, dịch vụ, thương hiệu hay liên kết nào (cộng đồng cấm quảng cáo / tự quảng bá)."
      guide: "${KHONG_SAN_PHAM} Cộng đồng có luật cấm quảng cáo / tự quảng bá: TUYỆT ĐỐI không nhắc, không ám chỉ sản phẩm, dịch vụ, thương hiệu hay liên kết nào của mình."
      max_words: 30
      max_chars: ${RD_TIEU_DE_TOI_DA}
    into: tieu_de_rd

  - id: soan_noi_dung_bai_rd_khong_qc
    when: "len(ds_luat_rd) > 0 and ds_luat_rd[0].cam_qc"
    generate:
      input: "Viết phần nội dung cho bài đăng Reddit có tiêu đề: {{tieu_de_rd}} — chủ đề: {{chu_de_dang_rd}}; như một thành viên cộng đồng, có ích, KHÔNG nhắc sản phẩm, dịch vụ, thương hiệu hay liên kết nào (cộng đồng cấm quảng cáo / tự quảng bá)."
      guide: "${KHONG_SAN_PHAM} Cộng đồng có luật cấm quảng cáo / tự quảng bá: TUYỆT ĐỐI không nhắc, không ám chỉ sản phẩm, dịch vụ, thương hiệu hay liên kết nào của mình."
      max_words: 220
      max_chars: ${TOI_DA_BAI}
    into: noi_dung_bai_rd

  - id: dang_bai_rd
    on: web
    do: "mở cộng đồng, bấm Create Post, gõ tiêu đề {{tieu_de_rd}} và nội dung rồi bấm Post"
    expect: "bài hiện trong cộng đồng"
    risk: high
    idempotent: unsafe
    timeout: 120s
    ledger: da_dang_bai_rd`,
  learned: {
    mo_cong_dong_dang_rd: { actions: [{ kind: "navigate", url: "{{cong_dong_dang_url}}" }], postcondition: [{ t: "url_contains", s: "/r/" }] },
    doc_luat_dang_rd: { extract_spec: RD_LUAT_SPEC },
    soan_tieu_de_rd: { dung_neu_sai: [{ dk: "len(trim(tieu_de_rd)) > 0", ly_do: "AI chưa soạn được tiêu đề — không đăng" }] },
    soan_noi_dung_bai_rd: { dung_neu_sai: [{ dk: "len(trim(noi_dung_bai_rd)) > 0", ly_do: "AI chưa soạn được nội dung — không đăng" }] },
    soan_tieu_de_rd_khong_qc: { dung_neu_sai: [{ dk: "len(trim(tieu_de_rd)) > 0", ly_do: "AI chưa soạn được tiêu đề — không đăng" }] },
    soan_noi_dung_bai_rd_khong_qc: { dung_neu_sai: [{ dk: "len(trim(noi_dung_bai_rd)) > 0", ly_do: "AI chưa soạn được nội dung — không đăng" }] },
    dang_bai_rd: {
      actions: RD_DANG_ACTIONS,
      postcondition: [{ t: "url_contains", s: "/comments/" }, { t: "text_visible", text: "{{ dau_chu(tieu_de_rd, 60) }}" }],
      dem_ngay: "dang_bai_kenh",
    },
  },
};

// ===================== X — ĐĂNG BÀI KÈM ẢNH =====================
// Khối RIÊNG (không sửa x/dang_bai: kịch bản / bản chụp hash cũ giữ nguyên). Cùng đường đăng đã đo thật của dang_bai (/compose/post → tweetTextarea_0 →
// tweetButton). CHƯA KIỂM TRÊN TRANG THẬT: input[data-testid=fileInput] trong hộp soạn /compose/post (đã đo nút "Thêm ảnh hoặc video" — dang_bai #31) và ảnh
// [data-testid=tweetPhoto] trong bài vừa đăng.
const X_DANG_BAI_ANH: KhoiMau = {
  ten: "dang_bai_anh",
  moTa: "Đăng MỘT bài mới trên X KÈM ẢNH từ Kho ảnh (kem_anh = luon / ti_le; anh_chon = tập ảnh chọn trong Kho ảnh): AI soạn bài ngắn (≤ 280 ký tự, không hashtag) theo chủ đề, mở /compose/post, đính ảnh vào hộp soạn rồi gõ, bấm Đăng (rủi ro cao — có duyệt). Không đính được ảnh → gửi chỉ chữ hoặc bỏ (khi_loi_anh). Hạn mức đăng bài lên kênh mỗi ngày (mặc định 3).",
  thamSo: [{ ten: "chu_de", moTa: "chủ đề/ý chính của bài đăng (một câu)", kieu: "chuoi", batBuoc: true }, ...TS_KEM_ANH_TAT_CA],
  params: { chu_de_anh_x: { type: "string", default: "{{ts.chu_de}}", label: "Chủ đề bài đăng kèm ảnh" } },
  trangThu: "https://x.com/compose/post (khảo sát dang_bai 04/10); đính ảnh: CHƯA kiểm trên trang thật",
  yamlSteps: `  - id: soan_bai_anh_x
    generate:
      input: "Viết MỘT bài đăng X (tối đa 280 ký tự, KHÔNG dùng hashtag, không liên kết) kèm một ảnh sản phẩm, về: {{chu_de_anh_x}}"
      guide: knowledge
      max_words: 40
      max_chars: 280
    into: bai_anh_x

  - id: dang_bai_anh_x
    on: web
    do: "mở trang soạn bài, đính ảnh, gõ {{bai_anh_x}} rồi bấm Đăng"
    expect: "thấy chữ 'đã được gửi'"
    risk: high
    idempotent: unsafe
    timeout: 90s
    ledger: da_dang_bai_anh_x`,
  learned: {
    dang_bai_anh_x: {
      actions: X_DANG_BAI_ACTIONS.map((a) => (a.kind === "type" ? { ...a, text: "{{bai_anh_x}}" } : a)),
      postcondition: [{ t: "dom_exists", sel: '[data-testid="toast"]' }],
      dem_ngay: "dang_bai_kenh",
      kem_anh: kemAnhHoc(1, X_HAU_KIEM_ANH, { ...X_KEM_ANH, ngu_canh: "{{chu_de_anh_x}}" }),
    },
  },
};

// ===================== CHỦ KÊNH: THẢ TIM / GHIM BÌNH LUẬN =====================
const TS_SO_VIDEO = { ten: "so_video", moTa: "số video mới nhất của mình sẽ xem bình luận (1-5)", kieu: "so" as const, batBuoc: true, min: 1, max: 5 };
const TS_SO_TIM = { ten: "so_tim", moTa: "số bình luận tối đa thả tim / thích MỖI LƯỢT, tính chung mọi video (0-10; 0 = chỉ ghim)", kieu: "so" as const, macDinh: "3", min: 0, max: 10 };
const TS_GHIM_CHU = { ten: "ghim_chu", moTa: "một đoạn chữ có trong bình luận muốn GHIM (chép đúng chữ người dùng đưa); bỏ trống = không ghim", kieu: "chuoi" as const, macDinh: "" };

// YouTube — CHƯA KIỂM TRÊN TRANG THẬT: nút tim chủ kênh #creator-heart-button (trạng thái đã tim aria-pressed / #hearted), menu Tác vụ #action-menu → "Ghim", hộp xác nhận.
const YT_BL_TG_SPEC = {
  mode: "list",
  list: { describe: "bình luận cấp 1 dưới video của kênh mình (để thả tim / ghim)", ladder: [{ t: "css", sel: "ytd-comment-thread-renderer" }] },
  fields: {
    nguoi: { sel: "#comment #author-text", attr: "text", alt: [":scope > ytd-comment-view-model #author-text", ":scope > ytd-comment-renderer #author-text"] },
    noi_dung: { sel: "#comment #content-text", attr: "text", alt: [":scope > ytd-comment-view-model #content-text", ":scope > ytd-comment-renderer #content-text"] },
    da_tim: { sel: '#comment #creator-heart-button [aria-pressed="true"], #comment #hearted', attr: "html", phan_loai: [{ re: "[\\s\\S]*", gt: "co" }], mac_dinh: "" },
  },
  item_key: "noi_dung",
};
const YT_NUT_TIM = { describe: "nút Thả tim (tim của chủ kênh) của bình luận này", within: "item", ladder: [
  { t: "css", sel: "#comment #creator-heart-button button" },
  { t: "css", sel: "#comment #creator-heart-button" },
] };
const YT_DA_TIM = { describe: "tim chủ kênh đã bật ở bình luận này", within: "item", ladder: [
  { t: "css", sel: '#comment #creator-heart-button [aria-pressed="true"]' },
  { t: "css", sel: "#comment #hearted" },
] };
const YT_GHIM_ACTIONS = [
  { kind: "click", target: { describe: "nút Tác vụ (⋮) của bình luận này để Ghim", within: "item", ladder: [{ t: "css", sel: "#comment #action-menu button" }, { t: "css", sel: "#comment #action-menu" }] } },
  { kind: "click", target: { describe: "mục 'Ghim' trong menu Tác vụ", ladder: [
    { t: "xpath", xpath: '(//ytd-menu-popup-renderer//ytd-menu-service-item-renderer[normalize-space()="Ghim" or normalize-space()="Pin"])[1]' },
  ] } },
  { kind: "click", target: { describe: "nút xác nhận Ghim", ladder: [
    { t: "xpath", xpath: '(//yt-confirm-dialog-renderer//*[@id="confirm-button"]//button)[1]' },
    { t: "xpath", xpath: '(//tp-yt-paper-dialog//button[normalize-space()="Ghim" or normalize-space()="Pin"])[1]' },
  ] } },
];
const YT_DA_GHIM = { describe: "nhãn 'Đã ghim' ở bình luận này", within: "item", ladder: [{ t: "css", sel: "#comment #pinned-comment-badge" }, { t: "css", sel: "#pinned-comment-badge" }] };
const YT_TIM_GHIM: KhoiMau = {
  ten: "tim_ghim_binh_luan",
  moTa: "CHỦ KÊNH thả tim / ghim bình luận dưới các video CỦA CHÍNH KÊNH MÌNH: máy đọc @handle kênh đang đăng nhập, mở trang Video, lần lượt so_video video mới nhất; thả tim tối đa so_tim bình luận của NGƯỜI KHÁC chưa có tim (bỏ của chính kênh, đã có tim — sổ cái); ghim MỘT bình luận có chữ ghim_chu (để trống = không ghim). Rủi ro cao — có duyệt. Dùng độc lập, không cần tìm kiếm.",
  thamSo: [TS_SO_VIDEO, TS_SO_TIM, TS_GHIM_CHU],
  params: { ghim_tg_yt: { type: "string", default: "{{ts.ghim_chu}}", label: "Chữ trong bình luận cần ghim (để trống = không ghim)" } },
  trangThu: "CHƯA kiểm trên trang thật: nút tim chủ kênh / menu Ghim (khảo sát 04/10 chỉ thấy bình luận dưới video người khác)",
  yamlSteps: `  - id: mo_trang_tg_yt
    on: web
    do: "mở YouTube để đọc kênh đang dùng"
    expect: "trang YouTube"

  - id: mo_menu_tg_yt
    on: web
    do: "bấm ảnh đại diện kênh (góc trên phải) để xem @handle kênh đang dùng"
    expect: "menu ảnh đại diện mở"
    timeout: 20s

  - id: lay_kenh_tg_yt
    on: web
    extract: "@handle kênh đang đăng nhập (menu ảnh đại diện)"
    into: kenh_tg_yt
    timeout: 10s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: dong_menu_tg_yt
    on: web
    do: "đóng menu ảnh đại diện (phím Esc)"
    optional: true

  - id: mo_video_tg_yt
    on: web
    do: "mở trang Video của kênh {{kenh_tg_yt}}"
    expect: "url chứa /videos"

  - id: lay_video_tg_yt
    on: web
    extract: "video của kênh mình, mới nhất trước: tieu_de, lien_ket"
    into: ds_video_tg_yt
    timeout: 20s

  - id: vong_video_tg_yt
    for_each: ds_video_tg_yt
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: mo_bl_tg_yt
        on: web
        do: "mở video {{item.lien_ket}} của kênh mình rồi cuộn tới khu bình luận"
        expect: "trang đúng video, có khu bình luận"
      - id: lay_bl_tg_yt
        on: web
        extract: "bình luận cấp 1: nguoi, noi_dung, da_tim"
        into: item.ds_bl
        timeout: 15s
      - id: tha_tim_bl_yt
        for_each: item.ds_bl
        max_items: 20
        when: "{{ts.so_tim}} > 0 and len(kenh_tg_yt) > 1 and len(str(item.noi_dung)) > 0 and lower(str(item.nguoi)) != lower(kenh_tg_yt) and not item.da_tim"
        on: web
        do: "bấm Thả tim (tim của chủ kênh) ở bình luận của {{ str(item.nguoi) }}"
        expect: "tim chủ kênh bật ở bình luận đó"
        risk: high
        idempotent: unsafe
        timeout: 30s
        on_item_error: skip
        ledger: da_tha_tim_bl
      - id: ghim_bl_yt
        for_each: item.ds_bl
        max_items: 20
        when: "len(trim(ghim_tg_yt)) > 0 and contains(lower(str(item.noi_dung)), lower(trim(ghim_tg_yt)))"
        on: web
        do: "mở menu Tác vụ của bình luận có chữ {{ghim_tg_yt}} rồi bấm Ghim"
        expect: "bình luận đó có nhãn Đã ghim"
        risk: high
        idempotent: unsafe
        timeout: 40s
        on_item_error: skip
        ledger: da_ghim_bl`,
  learned: {
    mo_trang_tg_yt: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    mo_menu_tg_yt: { actions: [{ kind: "click", target: { describe: "ảnh đại diện kênh (góc trên phải) — chưa đăng nhập YouTube thì không có nút này", ladder: [{ t: "css", sel: "button#avatar-btn" }, { t: "css", sel: "#avatar-btn" }] } }], postcondition: [{ t: "dom_exists", sel: "ytd-multi-page-menu-renderer" }] },
    lay_kenh_tg_yt: YT_LAY_KENH_MINH,
    dong_menu_tg_yt: { actions: [{ kind: "press", key: "Escape" }] },
    mo_video_tg_yt: { actions: [{ kind: "navigate", url: "{{goc}}{{kenh_tg_yt}}/videos" }], postcondition: [{ t: "url_contains", s: "{{kenh_tg_yt}}/videos" }] },
    lay_video_tg_yt: { extract_spec: YT_KENH_VIDEO_SPEC, khong_viec_khi_rong: "Kênh của bạn chưa có video nào — không có bình luận nào để thả tim / ghim" },
    vong_video_tg_yt: { con: {
      mo_bl_tg_yt: { actions: YT_MO_BINH_LUAN("{{item.lien_ket}}"), postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, { t: "dom_exists", sel: "#comments" }] },
      lay_bl_tg_yt: { extract_spec: YT_BL_TG_SPEC, khong_viec_khi_rong: "Các video của bạn chưa có bình luận nào — không có gì để thả tim / ghim" },
      tha_tim_bl_yt: { actions: [{ kind: "click", target: YT_NUT_TIM }], postcondition: [{ t: "locator_visible", target: YT_DA_TIM }], gioi_han_luot: "{{ts.so_tim}}" },
      ghim_bl_yt: { actions: YT_GHIM_ACTIONS, postcondition: [{ t: "locator_visible", target: YT_DA_GHIM }], gioi_han_luot: 1 },
    } },
  },
};

// TikTok — CHƯA KIỂM TRÊN TRANG THẬT: nút tim của TỪNG bình luận (+ trạng thái đã thích), nút "…" của bình luận → "Pin"/"Ghim", nhãn đã ghim.
const TT_BL_TG_SPEC = {
  mode: "list",
  list: { describe: "bình luận cấp 1 dưới video của mình (để thích / ghim)", ladder: [
    { t: "css", sel: 'div[class*="DivCommentObjectWrapper"]:has(> div[class*="DivCommentItemWrapper"])' },
    { t: "css", sel: 'div[class*="DivCommentObjectWrapper"]' },
  ] },
  fields: {
    nguoi: { sel: '[data-e2e="comment-username-1"]', attr: "text" },
    nguoi_id: { sel: 'div[class*="DivCommentItemWrapper"] a[href*="/@"]', attr: "href", regex: "/@([^/?#]+)", alt: ['a[href*="/@"]'] },
    noi_dung: { sel: '[data-e2e="comment-level-1"]', attr: "text" },
    da_thich: { sel: 'div[class*="DivCommentItemWrapper"] [data-e2e="comment-like-icon"][aria-pressed="true"], div[class*="DivCommentItemWrapper"] [aria-label*="Unlike"]', attr: "html", phan_loai: [{ re: "[\\s\\S]*", gt: "co" }], mac_dinh: "" },
  },
  item_key: "noi_dung",
};
const TT_CHOT = { cond: { t: "url_contains", s: "{{ ma_video(video_tg_tt_url) }}" }, ly_do: "trang đã tự chuyển sang video khác — không bấm (tránh thích / ghim nhầm bình luận của video khác)" };
const TT_NUT_THICH_BL = { describe: "nút Thích bình luận (tim) của bình luận này", within: "item", ladder: [
  { t: "css", sel: 'div[class*="DivCommentItemWrapper"] [data-e2e="comment-like-icon"]' },
  { t: "css", sel: 'div[class*="DivCommentItemWrapper"] div[class*="DivLikeContainer"]' },
] };
const TT_DA_THICH_BL = { describe: "tim của bình luận này đã bật", within: "item", ladder: [{ t: "css", sel: 'div[class*="DivCommentItemWrapper"] [data-e2e="comment-like-icon"][aria-pressed="true"]' }] };
const TT_GHIM_ACTIONS = [
  { kind: "click", target: { describe: "nút '…' (thêm) của bình luận này để Ghim", within: "item", ladder: [
    { t: "css", sel: 'div[class*="DivCommentItemWrapper"] [data-e2e="comment-more-icon"]' },
    { t: "css", sel: 'div[class*="DivCommentItemWrapper"] div[class*="DivMoreContainer"]' },
  ] }, chot: TT_CHOT },
  { kind: "click", target: { describe: "mục 'Pin' (Ghim) trong menu của bình luận", ladder: [
    { t: "xpath", xpath: '(//*[@role="menuitem" or @role="option" or self::li or self::button][normalize-space()="Pin" or normalize-space()="Ghim"])[1]' },
  ] }, chot: TT_CHOT },
];
const TT_DA_GHIM = { describe: "nhãn 'Pinned' / 'Đã ghim' ở bình luận này", within: "item", ladder: [{ t: "css", sel: '[data-e2e="comment-pinned"]' }, { t: "css", sel: 'div[class*="DivPinnedLabel"]' }] };
const TT_TIM_GHIM: KhoiMau = {
  ten: "tim_ghim_binh_luan",
  moTa: "CHỦ KÊNH thích (tim) / ghim bình luận dưới các video CỦA CHÍNH MÌNH trên TikTok: máy đọc nick đang đăng nhập, mở trang cá nhân, lần lượt so_video video mới nhất (bỏ video ghim); thích tối đa so_tim bình luận của NGƯỜI KHÁC chưa được thích (bỏ của chính mình — sổ cái); ghim MỘT bình luận có chữ ghim_chu (để trống = không ghim). Chốt đúng mã video trước khi bấm. Rủi ro cao — có duyệt.",
  thamSo: [TS_SO_VIDEO, TS_SO_TIM, TS_GHIM_CHU],
  params: { ghim_tg_tt: { type: "string", default: "{{ts.ghim_chu}}", label: "Chữ trong bình luận cần ghim (để trống = không ghim)" } },
  trangThu: "CHƯA kiểm trên trang thật (khảo sát TikTok 04/10 bị CAPTCHA): nút tim / menu Pin của bình luận",
  yamlSteps: `  - id: mo_trang_chu_tg_tt
    on: web
    do: "mở TikTok để đọc nick đang dùng"
    expect: "trang TikTok"

  - id: lay_nick_tg_tt
    on: web
    extract: "nick TikTok đang đăng nhập (liên kết Hồ sơ ở thanh bên)"
    into: nick_tg_tt
    timeout: 15s
    retry: { times: 2, backoff: [2s, 3s], only_if: [not_found] }

  - id: mo_ho_so_tg_tt
    on: web
    do: "mở trang cá nhân @{{nick_tg_tt}}"
    expect: "url chứa /@{{nick_tg_tt}}"

  - id: lay_video_tg_tt
    on: web
    extract: "video trên trang cá nhân của mình: lien_ket, ghim"
    into: ds_video_tg_tt
    timeout: 20s

  - id: bo_video_ghim_tg_tt
    filter: "not item.ghim and len(str(item.lien_ket)) > 0"
    into: ds_video_tg_tt

  - id: vong_video_tg_tt
    for_each: ds_video_tg_tt
    max_items: {{ts.so_video}}
    on_item_error: skip
    steps:
      - id: mo_bl_tg_tt
        on: web
        do: "mở video {{item.lien_ket}} của mình rồi mở bảng bình luận"
        expect: "trang đúng video, bảng bình luận mở"
      - id: ghi_video_tg_tt
        template: "{{item.lien_ket}}"
        into: video_tg_tt_url
      - id: lay_bl_tg_tt
        on: web
        extract: "bình luận cấp 1: nguoi, nguoi_id, noi_dung, da_thich"
        into: item.ds_bl
        timeout: 15s
      - id: thich_bl_tt
        for_each: item.ds_bl
        max_items: 20
        when: "{{ts.so_tim}} > 0 and len(nick_tg_tt) > 1 and len(str(item.noi_dung)) > 0 and lower(str(item.nguoi_id)) != lower(nick_tg_tt) and lower(str(item.nguoi)) != lower(nick_tg_tt) and not item.da_thich"
        on: web
        do: "bấm Thích (tim) bình luận của {{ str(item.nguoi) }}"
        expect: "tim của bình luận đó bật"
        risk: high
        idempotent: unsafe
        timeout: 30s
        on_item_error: skip
        ledger: da_thich_bl_tt
      - id: ghim_bl_tt
        for_each: item.ds_bl
        max_items: 20
        when: "len(trim(ghim_tg_tt)) > 0 and contains(lower(str(item.noi_dung)), lower(trim(ghim_tg_tt)))"
        on: web
        do: "mở menu của bình luận có chữ {{ghim_tg_tt}} rồi bấm Pin (Ghim)"
        expect: "bình luận đó có nhãn Đã ghim"
        risk: high
        idempotent: unsafe
        timeout: 40s
        on_item_error: skip
        ledger: da_ghim_bl_tt`,
  learned: {
    mo_trang_chu_tg_tt: { actions: [{ kind: "navigate", url: "{{goc}}" }] },
    lay_nick_tg_tt: { extract_spec: TT_NICK_SPEC },
    mo_ho_so_tg_tt: { actions: [{ kind: "navigate", url: "{{goc}}@{{nick_tg_tt}}" }], postcondition: [{ t: "url_contains", s: "/@{{nick_tg_tt}}" }] },
    lay_video_tg_tt: { extract_spec: TT_VIDEO_CA_NHAN_SPEC, khong_viec_khi_rong: "Trang cá nhân TikTok của bạn chưa có video nào — không có bình luận nào để thích / ghim" },
    bo_video_ghim_tg_tt: { ly_do_bo: "video ghim (không phải video mới nhất)" },
    vong_video_tg_tt: { con: {
      mo_bl_tg_tt: { actions: TT_MO_BINH_LUAN("{{item.lien_ket}}"), postcondition: [{ t: "url_contains", s: "{{ ma_video(item.lien_ket) }}" }, { t: "dom_exists", sel: '[data-e2e="comment-text"]' }] },
      lay_bl_tg_tt: { extract_spec: TT_BL_TG_SPEC, khong_viec_khi_rong: "Các video của bạn chưa có bình luận nào — không có gì để thích / ghim" },
      thich_bl_tt: { actions: [{ kind: "click", target: TT_NUT_THICH_BL, chot: TT_CHOT }], postcondition: [{ t: "locator_visible", target: TT_DA_THICH_BL }], gioi_han_luot: "{{ts.so_tim}}" },
      ghim_bl_tt: { actions: TT_GHIM_ACTIONS, postcondition: [{ t: "locator_visible", target: TT_DA_GHIM }], gioi_han_luot: 1 },
    } },
  },
};

/** Khối nhóm 2 theo mạng — nối vào thư viện ở src/shared/khoi-thu-vien.ts. */
export const KHOI_XAY_KENH: Readonly<Record<"facebook" | "x" | "tiktok" | "youtube" | "reddit", KhoiMau[]>> = {
  facebook: [FB_DANG_TUONG],
  x: [X_DANG_BAI_ANH],
  tiktok: [TT_TIM_GHIM],
  youtube: [YT_DANG_CD, YT_TIM_GHIM],
  reddit: [RD_DANG_BAI],
};

export const HIEN_THI_XAY_KENH: Readonly<Record<string, { bieuTuong: string; tenNgan: string; mauMoTa: string }>> = {
  "facebook/dang_bai_tuong": { bieuTuong: "📝", tenNgan: "Đăng bài lên trang cá nhân", mauMoTa: "Đăng một bài lên trang cá nhân (tường)[ AI soạn về “{chu_de}”][ nội dung “{noi_dung}”][ — kèm ảnh: {kem_anh}]" },
  "x/dang_bai_anh": { bieuTuong: "🖼️", tenNgan: "Đăng bài kèm ảnh", mauMoTa: "Đăng một bài mới trên X do AI soạn về “{chu_de}” (≤ 280 ký tự)[ — kèm ảnh: {kem_anh}][ (ảnh: {anh_chon})]" },
  "youtube/dang_bai_cong_dong": { bieuTuong: "📣", tenNgan: "Đăng bài Cộng đồng", mauMoTa: "Đăng một bài Cộng đồng lên tab Bài đăng của kênh mình[ AI soạn về “{chu_de}”][ nội dung “{noi_dung}”]" },
  "reddit/dang_bai": { bieuTuong: "📝", tenNgan: "Đăng bài vào cộng đồng", mauMoTa: "Đọc luật rồi đăng một bài vào {cong_dong_url} — AI soạn tiêu đề + nội dung về “{chu_de}” (cộng đồng cấm quảng cáo thì không nhắc sản phẩm)" },
  "youtube/tim_ghim_binh_luan": { bieuTuong: "❤️", tenNgan: "Thả tim / ghim bình luận (chủ kênh)", mauMoTa: "Mở {so_video} video mới nhất của kênh mình, thả tim tối đa {so_tim} bình luận của người khác[, ghim bình luận có chữ “{ghim_chu}”]" },
  "tiktok/tim_ghim_binh_luan": { bieuTuong: "❤️", tenNgan: "Thích / ghim bình luận (chủ kênh)", mauMoTa: "Mở {so_video} video mới nhất của mình (bỏ video ghim), thích tối đa {so_tim} bình luận của người khác[, ghim bình luận có chữ “{ghim_chu}”]" },
};
export const NHAN_XAY_KENH: Readonly<Record<string, string>> = {
  so_tim: "Số bình luận thả tim tối đa mỗi lượt",
  ghim_chu: "Chữ trong bình luận cần ghim",
};
